/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopOfferCell_offer$ref: FragmentReference;
declare export opaque type TopOfferCell_offer$fragmentType: TopOfferCell_offer$ref;
export type TopOfferCell_offer = {|
  +id: string,
  +title: string,
  +startDate: any,
  +endDate: any,
  +store: {|
    +name: string
  |},
  +$refType: TopOfferCell_offer$ref,
|};
export type TopOfferCell_offer$data = TopOfferCell_offer;
export type TopOfferCell_offer$key = {
  +$data?: TopOfferCell_offer$data,
  +$fragmentRefs: TopOfferCell_offer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopOfferCell_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Offer"
};
// prettier-ignore
(node/*: any*/).hash = '7bac1f9206f87bf118ee5977b2a8d906';

module.exports = node;
